export default __webpack_public_path__ + "static/media/start_assign.c65c476a.svg";